/* eslint-disable @typescript-eslint/no-unused-vars */
/* globals angular */
import CONSTANTS from '~/constants'

function debounce(func, wait, immediate) {
  let timeout
  return function() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this
    // eslint-disable-next-line prefer-rest-params
    const args = arguments
    const later = function() {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

function monitoring($http, $q, $location, $rootScope, $window, toastr, fn) {
  const getElementDetails = (elm) => {
    const details = {}
    const props = ['nodeName']
    const attrs = [
      'ng-model',
      'id',
      'name',
      'title',
      'placeholder',
      'data-index',
      'href',
      'class',
      'data-original-title',
    ]
    props.forEach((key) => {
      if (elm[key]) {
        details[key] = elm[key]
      }
    })
    if (elm.getAttribute) {
      attrs.forEach((key) => {
        if (elm.getAttribute(key)) {
          details[key] = elm.getAttribute(key)
        }
      })
    }
    // if (document.activeElement) details.activeElement = document.activeElement.nodeName
    return details
  }

  const getEventDetails = (evt) => {
    const details = {}
    const props = [
      'type',
      'screenX',
      'screenY',
      'which',
      'ctrlKey',
      'shiftKey',
      'metaKey',
    ]
    props.forEach((key) => {
      if (evt[key]) {
        details[key] = evt[key]
      }
    })
    return details
  }

  $rootScope.$on('LOG_USER_EVENT', (info, action) => {
    this.addAction(action)
  })
  const recordEvent = (evt) => {
    this.addAction({
      event: getEventDetails(evt),
      element: getElementDetails(evt.target),
      loadId: window.__loadId__,
    })
  }

  this.init = () => {
    const win = angular.element(window)
    win.on('resize', debounce(recordEvent, 200, false))
    win.on('mousedown', recordEvent)
    win.on('keydown', recordEvent)
    win.on('paste', recordEvent)
    win.on('cut', recordEvent)
    win.on('error', (messageOrEvent, source, lineno, colno, error) => {
      const details = {
        event: {
          type: 'error',
          messageOrEvent,
          source,
          lineno,
          colno,
          error,
        },
      }
      this.addAction(details)
    })

    // tab claiming
    this.tabStoryId = ''

    $rootScope.$on('ELLIPSIS_STORY_LOADED', (storyId) => {
      this.claimStory(storyId)
    })

    // reassert claim when coming back to tab
    $window.addEventListener('focus', (e) => {
      if (this.tabStoryId) {
        this.claimStory(this.tabStoryId)
      }
    })
  }

  const actions = []
  let timer
  this.addAction = (o) => {
    const action = {
      page: $location
        .absUrl()
        .split(CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI)
        .pop(),
      ts: new Date().getTime(),
      details: o,
    }
    actions.unshift(action)
    if (timer) window.clearTimeout(timer)
  }

  this.claimStory = (storyId) => {
    this.tabStoryId = '' + storyId
    window.localStorage.removeItem('ellipsis-tab-story', storyId)
    window.localStorage.setItem('ellipsis-tab-story', storyId)
  }
}

export default [
  '$http',
  '$q',
  '$location',
  '$rootScope',
  '$window',
  'toastr',
  'fnService',
  monitoring,
]
